import React, { useEffect, useState } from "react";
import { SectionWrapper } from "../../hoc";
// import the corresponding css file
import "./Engineering.css";
// import the separated file related to the component
import EC20Engineering from "./EC20Engineering/EC20Engineering";
import SpaCEngineering from "./SpaCEngineering/SpaCEngineering";
import HGTEngineering from "./HorizontalGeneTransfer/HGTEngineering";
import Overview from "./Overview/Overview";
// import the image you want for the top of the page
import { BacteriaSlider } from "../utils";
import { RingLoader } from "react-spinners";
import { scrollToId } from "../../utils/scrollToId";
const Engineering = ({ setDisplayNavBar }) => {
  const [loading, setLoading] = useState(true);
  // when the page is loaded from the navbar, it sets the position of the user at the top of the page
  useEffect(() => {
   // Simulate a delay (remove this in your actual implementation)
   let url = window.location.href
   let lastLetter = url.charAt(url.length - 1)
   let secondLastLetter = url.charAt(url.length - 2)
   
   if(secondLastLetter === "_"){
    if(lastLetter === "o"){
      setPage(1)
    } else if(lastLetter === "e"){
        setPage(2)
    }else if(lastLetter==="s"){
      setPage(3)
    }else if(lastLetter==="h"){
      setPage(4)
    }
   
}
    setTimeout(() => {
      setLoading(false); // Set loading to false after a delay
    }, 2000); // Simulated delay of 2 seconds
  }, []);
  useEffect(() => {
    setDisplayNavBar(!loading);
    if(!loading){
      scrollToId()
    }
  }, [loading, setDisplayNavBar]);

  const [page, setPage] = useState(1);
  const sliderHandle = (newValue) => {
    setPage(newValue);
  };

  return (
    <>
      {/* Display the content of the page on the entire viewport */}
      <div className="relative">
        {loading ? (<div className="spinner-container fixed h-screen w-screen bg-white z-10">
          <RingLoader color="#BA55D3" loading={loading} />{" "}
          <script>{document.body.style.overflow = 'hidden'}</script>
        </div>): <script>{document.body.style.overflow = 'auto'}</script>}
      
        <>
         {/* Set the size and crop the image on top of the page */}
        <div className="top-page">
          <h1>Engineering</h1>
        </div>
        {/* divide the section in columns */}
        {/* main content which is a separated file you call and it is displayed on the right of the section above */}
        <BacteriaSlider value={page} onChange={sliderHandle}  sliderMarks={{1:"Overview", 2:"EC20", 3:"SpaC", 4:"H.G.T"}} size={4}/>
        <main style={{ marginRight: "50px" }}>
          {page === 1 ?(
            <div className="fade-in mt-[2rem]">
              <Overview />
            </div>
          ):
          page === 2 ? (
            <div className="fade-in1 mt-[2rem]">
              <EC20Engineering />
            </div>
          ) : page === 3 ? (
            <div className="fade-in2 mt-[2rem]">
              <SpaCEngineering />
            </div>
          ) : (
            <div className="fade-in3 mt-[2rem]">
              <HGTEngineering />
            </div>
          )}
        </main>
      </></div>
    </>
  );
};

// don't forget to change the name of the component you're exporting
export default SectionWrapper(Engineering, "engineering");
